import { createStore } from "zustand-x"
import type { TournamentDetail } from "@/domain/tournament/model/Tournament"

interface TournamentDetailStoreState {
  detail: TournamentDetail | null
  isLoaded: boolean
  errorMessage: string
}

function makeInitTournamentDetailState(): TournamentDetailStoreState {
  return {
    detail: null,
    isLoaded: false,
    errorMessage: "",
  }
}

const TournamentDetailStore = createStore<TournamentDetailStoreState>(
  makeInitTournamentDetailState(),
  { name: "TournamentDetailStore" },
)

export { TournamentDetailStore, makeInitTournamentDetailState }
export type { TournamentDetailStoreState }
